module.exports = __webpack_public_path__ + "img/0ffddc0.jpg";